// extracted by mini-css-extract-plugin
export default {"chip__container":"ChipContainer_chip__container__7TY4I","-chip":"ChipContainer_-chip__4DmTq"};